import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useSuperAuth } from "../../context/SuperAuthContext";
import { LogOut, Building2, User } from "lucide-react";

export default function SuperLayout() {
  const { sa, logout } = useSuperAuth();
  const nav = useNavigate();
  if (!sa) return null;

  const handleLogout = () => { logout(); nav("/super/login"); };

  const links = [
    { to: "/super/clientes", label: "Clientes", icon: Building2, testid: "super-nav-clientes" },
    { to: "/super/minha-conta", label: "Minha Conta", icon: User, testid: "super-nav-conta" },
  ];

  return (
    <div className="min-h-screen bg-zinc-50 text-zinc-900">
      <header className="sticky top-0 z-30 border-b border-brand-100/60 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 md:px-8">
          <div className="flex items-center gap-3">
            <img src="/fila-gestao-logo.png?v=2" alt="FILA Gestão" className="h-10 w-10 object-contain" />
            <div>
              <div className="text-sm font-semibold leading-none">FILA <span className="text-brand-500">Gestão</span></div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">Super Admin</div>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-full px-4 py-2 text-sm transition-colors ${
                    isActive ? "bg-brand-500 text-white shadow-sm shadow-brand-500/20" : "text-zinc-600 hover:bg-brand-50 hover:text-brand-600"
                  }`
                }
              >
                <l.icon size={14} />{l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <div className="text-sm font-medium leading-none">{sa.name}</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">{sa.email}</div>
            </div>
            <button
              data-testid="super-btn-logout"
              onClick={handleLogout}
              className="rounded-full border border-zinc-200 bg-white p-2 text-zinc-500 hover:border-brand-300 hover:text-brand-600"
              aria-label="Sair"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
        <nav className="flex overflow-x-auto border-t border-brand-100/60 md:hidden">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) =>
                `flex flex-1 min-w-max items-center justify-center gap-2 px-4 py-3 text-xs font-medium ${
                  isActive ? "border-b-2 border-brand-500 text-brand-600" : "text-zinc-500"
                }`
              }
            >
              <l.icon size={14} /> {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6 md:px-8 md:py-10">
        <Outlet />
      </main>
      <footer className="border-t border-brand-100/60 bg-white/70 px-4 py-4 md:px-8">
        <div className="mx-auto max-w-6xl text-center text-[11px] text-zinc-500">
          FILA Gestão · Super Admin · Desenvolvido por <span className="font-medium text-zinc-700">Elite Tecnologia</span> · © {new Date().getFullYear()}
        </div>
      </footer>
    </div>
  );
}
